export const resourceTypeCsmGlobalCustomerAccessSettings = 'CSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS';
